<div class="container-menu-top" [class.close]="!menuLeftService.menuLeftOpen()">

    <!-- Empresa atual / Seletor de empresas (admin RapiDocs) -->
    <div
        clickOutside
        class="container-company-selector"
        [class.is-selectable]="canSwitchCompanies()"
        [clickOutsideEnabled]="showCompanyList()"
        (clickOutside)="showCompanyList.set(false)">

        <button
            type="button"
            class="company-trigger"
            [disabled]="!canSwitchCompanies()"
            (click)="toggleCompanyList()">

            <!-- Nome da empresa -->
            <div class="conatiner-company-logo">
                @if (companyLogo(); as logo) {
                    <img
                        [src]="logo"
                        [attr.alt]="companyController.currentCompany()?.name || 'RapiDocs'"
                        (error)="onLogoError()" />
                } @else {
                    <span class="company-logo-fallback" aria-hidden="true">{{ companyInitials() }}</span>
                }

                <!-- Nome da empresa -->
                <div class="container-company-name">
                    <ra-gradient-text class="ra-label-m bold">
                        {{ companyController.currentCompany()?.name }}
                    </ra-gradient-text>
                </div>
            </div>

            <!-- Chevron (quando o seletor está disponível) -->
            @if (canSwitchCompanies()) {
                <ra-icon
                    class="company-chevron"
                    [icon]="showCompanyList() ? 'arrow-up' : 'arrow-down'"
                    [varColor]="'contentSecondary'"
                    [size]="18" />
            }
        </button>

        <!-- Lista de empresas -->
        @if (canSwitchCompanies() && showCompanyList()) {
            <div class="container-company-list" (click)="$event.stopPropagation()">

                <!-- Busca (só admin RapiDocs, que lista muitas empresas) -->
                @if (isRapidocsAdmin()) {
                <div class="company-search">
                    <ra-icon [icon]="'search-normal'" [varColor]="'contentTertiary'" [size]="16" />
                    <input
                        type="text"
                        class="ra-label-s"
                        [value]="companySearch()"
                        [placeholder]="'menuTop.searchCompany' | translate"
                        (input)="companySearch.set($any($event.target).value)" />
                </div>
                }

                <!-- Opções -->
                <div class="company-options">
                    @for (company of filteredCompanies(); track company._id) {
                        <button
                            type="button"
                            class="company-option"
                            [class.active]="isCurrentCompany(company)"
                            [disabled]="companyChanging()"
                            (click)="changeCompany(company)">

                            <span class="company-avatar">
                                @if (company.logo) {
                                    <img [src]="company.logo" [attr.alt]="company.name" />
                                } @else {
                                    {{ (company.name || '?').charAt(0) }}
                                }
                            </span>

                            <span class="company-option-name ra-label-s">
                                {{ company.name || ('menuTop.companyNotFound' | translate) }}
                            </span>

                            <!-- Favoritar / desfavoritar (não dispara a troca) -->
                            <span
                                class="company-fav"
                                [class.active]="isFavorite(company)"
                                [raTooltip]="{
                                    text:
                                        (isFavorite(company)
                                            ? 'menuTop.removeFavorite'
                                            : 'menuTop.addFavorite'
                                        ) | translate,
                                    position: 'left'
                                }"
                                (click)="toggleFavorite(company, $event)">
                                <ra-icon [icon]="'star'" [size]="16" />
                            </span>

                            @if (isCurrentCompany(company)) {
                                <ra-icon class="company-tick" [icon]="'tick'" [varColor]="'contentPrimary'" [size]="16" />
                            }
                        </button>
                    } @empty {
                        <p class="company-empty ra-label-s">
                            {{ 'menuTop.noCompaniesFound' | translate }}
                        </p>
                    }
                </div>
            </div>
        }
    </div>
    
    <!-- Right side -->
    <div class="container-right-side">
    
        <!-- Action icons -->
        <div class="container-action-icons">

            <!--
                Atalho das integrações: só existe para quem AINDA NÃO vinculou
                nenhum canal, e some sozinho quando o primeiro vínculo fecha. É o
                caminho permanente de quem fechou a apresentação na home e não
                acharia a aba sozinho.

                É a única peça colorida da barra, de propósito: pílula na cor
                primária com a marca de cada canal ligado (um ícone por canal,
                para não mentir sobre o que há do outro lado) e um halo pulsando
                como chamada para a novidade.
            -->
            @if (showIntegrationsShortcut()) {
                <a
                    class="container-integrations-shortcut"
                    [routerLink]="'/platform/settings/integrations'"
                    [raTooltip]="{ text: 'menuTop.integrationsTooltip' | translate, position: 'bottom' }">
                    <span class="channel-brands" aria-hidden="true">
                        @for (brand of shortcutBrands(); track brand.icon) {
                            <ra-icon [icon]="brand.icon" [varColor]="brand.color" [size]="16" />
                        }
                    </span>
                    <span class="ra-label-s bold">{{ 'integrations.title' | translate }}</span>
                </a>
            }

            <!-- Notifications -->
            <div 
                clickOutside 
                class="container-notifications" 
                [clickOutsideEnabled]="showNotificationList()"
                (clickOutside)="showNotificationList.set(false)"
                (click)="toggleNotificationList()">
                <ra-icon [icon]="'notification-bell'" [varColor]="'contentTertiary'" [size]="21" />

                <!-- Unread count badge -->
                @if (notificationController.unreadCount() > 0) {
                    <div class="container-has-notifications">
                        {{ notificationController.unreadCount() > 9 ? '9+' : notificationController.unreadCount() }}
                    </div>
                }

                <!-- Notification list -->
                @if (showNotificationList()) {
                    <notification-list />
                }
            </div>

            <!-- Divider -->
            <div class="container-divider"></div>

            <!-- User (clique abre os dados do usuário) -->
            @let user = userController.currentUser();
            <div
                class="container-user-avatar"
                [routerLink]="'./settings/user'"
                [raTooltip]="{ text: user?.name ?? '', position: 'bottom' }">
                <ra-user-avatar [avatarSize]="30" [user]="user" />
            </div>
        </div>
    </div>
</div>


